import * as _ from 'lodash'

class InputService {
  ACCEPTED_KEYS = [
    { code: 'KeyQ', x: 1, y: 1 },
    { code: 'KeyW', x: 2, y: 1 },
    { code: 'KeyE', x: 3, y: 1, label: 'エ' },
    { code: 'KeyR', x: 4, y: 1 },
    { code: 'KeyT', x: 6, y: 1 },
    { code: 'KeyY', x: 8, y: 1 },
    { code: 'KeyU', x: 10, y: 1, label: 'ウ' },
    { code: 'KeyI', x: 11, y: 1, label: 'イ' },
    { code: 'KeyO', x: 12, y: 1, label: 'オ' },
    { code: 'KeyP', x: 13, y: 1 },

    { code: 'KeyA', x: 1, y: 2, label: 'ア' },
    { code: 'KeyS', x: 2, y: 2 },
    { code: 'KeyD', x: 3, y: 2 },
    { code: 'KeyF', x: 4, y: 2, label: 'ふぁ', subLabel: '_' },
    { code: 'KeyG', x: 6, y: 2, label: 'が', subLabel: 'G' },
    { code: 'KeyH', x: 8, y: 2, label: 'は', subLabel: 'H' },
    { code: 'KeyJ', x: 10, y: 2, label: 'じゃ', subLabel: '_' },
    { code: 'KeyK', x: 11, y: 2, line: null, step: 'か', label: 'か' },
    { code: 'KeyL', x: 12, y: 2 },
    { code: 'Semicolon', x: 13, y: 2 },

    { code: 'KeyZ', x: 1, y: 3 },
    { code: 'KeyX', x: 2, y: 3 },
    { code: 'KeyC', x: 3, y: 3 },
    { code: 'KeyV', x: 4, y: 3 },
    { code: 'KeyB', x: 6, y: 3 },
    { code: 'KeyN', x: 8, y: 3 },
    { code: 'KeyM', x: 10, y: 3 },
    { code: 'Comma', x: 11, y: 3 },
    { code: 'Period', x: 12, y: 3 },
    { code: 'Slash', x: 13, y: 3 },
    { code: 'Minus', x: 13, y: 1 }
  ]

  CONVERSION_PATTERNS = [
    { input: 'a', output: 'あ' },
    { input: 'i', output: 'い' },
    { input: 'u', output: 'う' },
    { input: 'e', output: 'え' },
    { input: 'o', output: 'お' },

    { input: 'ka', output: 'か' },
    { input: 'ki', output: 'き' },
    { input: 'ku', output: 'く' },
    { input: 'ke', output: 'け' },
    { input: 'ko', output: 'こ' },

    { input: 'kka', output: 'っか' },
    { input: 'kki', output: 'っき' },
    { input: 'kku', output: 'っく' },
    { input: 'kke', output: 'っけ' },
    { input: 'kko', output: 'っこ' },

    { input: 'ga', output: 'が' },
    { input: 'gi', output: 'ぎ' },
    { input: 'gu', output: 'ぐ' },
    { input: 'ge', output: 'げ' },
    { input: 'go', output: 'ご' },

    { input: 'gga', output: 'っが' },
    { input: 'ggi', output: 'っぎ' },
    { input: 'ggu', output: 'っぐ' },
    { input: 'gge', output: 'っげ' },
    { input: 'ggo', output: 'っご' },

    { input: 'sa', output: 'さ' },
    { input: 'si', output: 'し' },
    { input: 'su', output: 'す' },
    { input: 'se', output: 'せ' },
    { input: 'so', output: 'そ' },

    { input: 'ssa', output: 'っさ' },
    { input: 'ssi', output: 'っし' },
    { input: 'ssu', output: 'っす' },
    { input: 'sse', output: 'っせ' },
    { input: 'sso', output: 'っそ' },

    { input: 'za', output: 'ざ' },
    { input: 'zi', output: 'じ' },
    { input: 'zu', output: 'ず' },
    { input: 'ze', output: 'ぜ' },
    { input: 'zo', output: 'ぞ' },

    { input: 'zza', output: 'っざ' },
    { input: 'zzi', output: 'っじ' },
    { input: 'zzu', output: 'っず' },
    { input: 'zze', output: 'っぜ' },
    { input: 'zzo', output: 'っぞ' },

    { input: 'ta', output: 'た' },
    { input: 'ti', output: 'ち' },
    { input: 'tu', output: 'つ' },
    { input: 'te', output: 'て' },
    { input: 'to', output: 'と' },

    { input: 'tta', output: 'った' },
    { input: 'tti', output: 'っち' },
    { input: 'ttu', output: 'っつ' },
    { input: 'tte', output: 'って' },
    { input: 'tto', output: 'っと' },

    { input: 'tsa', output: 'つぁ' },
    { input: 'tsi', output: 'つぃ' },
    { input: 'tsu', output: 'つ' },
    { input: 'tse', output: 'つぇ' },
    { input: 'tso', output: 'つぉ' },

    { input: 'ttsa', output: 'っつぁ' },
    { input: 'ttsi', output: 'っつぃ' },
    { input: 'ttsu', output: 'っつ' },
    { input: 'ttse', output: 'っつぇ' },
    { input: 'ttso', output: 'っつぉ' },

    { input: 'da', output: 'だ' },
    { input: 'di', output: 'ぢ' },
    { input: 'du', output: 'づ' },
    { input: 'de', output: 'で' },
    { input: 'do', output: 'ど' },

    { input: 'dda', output: 'っだ' },
    { input: 'ddi', output: 'っぢ' },
    { input: 'ddu', output: 'っづ' },
    { input: 'dde', output: 'っで' },
    { input: 'ddo', output: 'っど' },

    { input: 'na', output: 'な' },
    { input: 'ni', output: 'に' },
    { input: 'nu', output: 'ぬ' },
    { input: 'ne', output: 'ね' },
    { input: 'no', output: 'の' },

    { input: 'ha', output: 'は' },
    { input: 'hi', output: 'ひ' },
    { input: 'hu', output: 'ふ' },
    { input: 'he', output: 'へ' },
    { input: 'ho', output: 'ほ' },

    { input: 'hha', output: 'っは' },
    { input: 'hhi', output: 'っひ' },
    { input: 'hhu', output: 'っふ' },
    { input: 'hhe', output: 'っへ' },
    { input: 'hho', output: 'っほ' },

    { input: 'ba', output: 'ば' },
    { input: 'bi', output: 'び' },
    { input: 'bu', output: 'ぶ' },
    { input: 'be', output: 'べ' },
    { input: 'bo', output: 'ぼ' },

    { input: 'bba', output: 'っば' },
    { input: 'bbi', output: 'っび' },
    { input: 'bbu', output: 'っぶ' },
    { input: 'bbe', output: 'っべ' },
    { input: 'bbo', output: 'っぼ' },

    { input: 'pa', output: 'ぱ' },
    { input: 'pi', output: 'ぴ' },
    { input: 'pu', output: 'ぷ' },
    { input: 'pe', output: 'ぺ' },
    { input: 'po', output: 'ぽ' },

    { input: 'ppa', output: 'っぱ' },
    { input: 'ppi', output: 'っぴ' },
    { input: 'ppu', output: 'っぷ' },
    { input: 'ppe', output: 'っぺ' },
    { input: 'ppo', output: 'っぽ' },

    { input: 'ma', output: 'ま' },
    { input: 'mi', output: 'み' },
    { input: 'mu', output: 'む' },
    { input: 'me', output: 'め' },
    { input: 'mo', output: 'も' },

    { input: 'mma', output: 'っま' },
    { input: 'mmi', output: 'っみ' },
    { input: 'mmu', output: 'っむ' },
    { input: 'mme', output: 'っめ' },
    { input: 'mmo', output: 'っも' },

    { input: 'ya', output: 'や' },
    { input: 'yu', output: 'ゆ' },
    { input: 'ye', output: 'いぇ' },
    { input: 'yo', output: 'よ' },

    { input: 'yya', output: 'っや' },
    { input: 'yyu', output: 'っゆ' },
    { input: 'yye', output: 'っいぇ' },
    { input: 'yyo', output: 'っよ' },

    { input: 'ra', output: 'ら' },
    { input: 'ri', output: 'り' },
    { input: 'ru', output: 'る' },
    { input: 're', output: 'れ' },
    { input: 'ro', output: 'ろ' },

    { input: 'rra', output: 'っら' },
    { input: 'rri', output: 'っり' },
    { input: 'rru', output: 'っる' },
    { input: 'rre', output: 'っれ' },
    { input: 'rro', output: 'っろ' },

    { input: 'wa', output: 'わ' },
    { input: 'wi', output: 'うぃ' },
    { input: 'we', output: 'うぇ' },
    { input: 'wo', output: 'を' },
    { input: 'nn', output: 'ん' },

    { input: 'wwa', output: 'っわ' },
    { input: 'wwi', output: 'っうぃ' },
    { input: 'wwe', output: 'っうぇ' },
    { input: 'wwo', output: 'っを' },

    { input: 'xa', output: 'ぁ' },
    { input: 'xi', output: 'ぃ' },
    { input: 'xu', output: 'ぅ' },
    { input: 'xe', output: 'ぇ' },
    { input: 'xo', output: 'ぉ' },

    { input: 'xxa', output: 'っぁ' },
    { input: 'xxi', output: 'っぃ' },
    { input: 'xxu', output: 'っぅ' },
    { input: 'xxe', output: 'っぇ' },
    { input: 'xxo', output: 'っぉ' },

    { input: 'la', output: 'ぁ' },
    { input: 'li', output: 'ぃ' },
    { input: 'lu', output: 'ぅ' },
    { input: 'le', output: 'ぇ' },
    { input: 'lo', output: 'ぉ' },

    { input: 'lla', output: 'っぁ' },
    { input: 'lli', output: 'っぃ' },
    { input: 'llu', output: 'っぅ' },
    { input: 'lle', output: 'っぇ' },
    { input: 'llo', output: 'っぉ' },

    { input: 'kya', output: 'きゃ' },
    { input: 'kyi', output: 'きぃ' },
    { input: 'kyu', output: 'きゅ' },
    { input: 'kye', output: 'きぇ' },
    { input: 'kyo', output: 'きょ' },

    { input: 'kkya', output: 'っきゃ' },
    { input: 'kkyi', output: 'っきぃ' },
    { input: 'kkyu', output: 'っきゅ' },
    { input: 'kkye', output: 'っきぇ' },
    { input: 'kkyo', output: 'っきょ' },

    { input: 'qa', output: 'くぁ' },
    { input: 'qi', output: 'くぃ' },
    { input: 'qu', output: 'くぅ' },
    { input: 'qe', output: 'くぇ' },
    { input: 'qo', output: 'くぉ' },

    { input: 'qqa', output: 'っくぁ' },
    { input: 'qqi', output: 'っくぃ' },
    { input: 'qqu', output: 'っくぅ' },
    { input: 'qqe', output: 'っくぇ' },
    { input: 'qqo', output: 'っくぉ' },

    { input: 'qwa', output: 'くぁ' },
    { input: 'qwi', output: 'くぃ' },
    { input: 'qwu', output: 'くぅ' },
    { input: 'qwe', output: 'くぇ' },
    { input: 'qwo', output: 'くぉ' },

    { input: 'qqwa', output: 'っくゎ' },
    { input: 'qqwi', output: 'っくぃ' },
    { input: 'qqwu', output: 'っくぅ' },
    { input: 'qqwe', output: 'っくぇ' },
    { input: 'qqwo', output: 'っくぉ' },

    { input: 'gya', output: 'ぎゃ' },
    { input: 'gyi', output: 'ぎぃ' },
    { input: 'gyu', output: 'ぎゅ' },
    { input: 'gye', output: 'ぎぇ' },
    { input: 'gyo', output: 'ぎょ' },

    { input: 'ggya', output: 'っぎゃ' },
    { input: 'ggyi', output: 'っぎぃ' },
    { input: 'ggyu', output: 'っぎゅ' },
    { input: 'ggye', output: 'っぎぇ' },
    { input: 'ggyo', output: 'っぎょ' },

    { input: 'gwa', output: 'ぐぁ' },
    { input: 'gwi', output: 'ぐぃ' },
    { input: 'gwu', output: 'ぐぅ' },
    { input: 'gwe', output: 'ぐぇ' },
    { input: 'gwo', output: 'ぐぉ' },

    { input: 'ggwa', output: 'っぐぁ' },
    { input: 'ggwi', output: 'っぐぃ' },
    { input: 'ggwu', output: 'っぐぅ' },
    { input: 'ggwe', output: 'っぐぇ' },
    { input: 'ggwo', output: 'っぐぉ' },

    { input: 'sya', output: 'しゃ' },
    { input: 'syi', output: 'しぃ' },
    { input: 'syu', output: 'しゅ' },
    { input: 'sye', output: 'しぇ' },
    { input: 'syo', output: 'しょ' },

    { input: 'ssya', output: 'っしゃ' },
    { input: 'ssyi', output: 'っしぃ' },
    { input: 'ssyu', output: 'っしゅ' },
    { input: 'ssye', output: 'っしぇ' },
    { input: 'ssyo', output: 'っしょ' },

    { input: 'sha', output: 'しゃ' },
    { input: 'shi', output: 'し' },
    { input: 'shu', output: 'しゅ' },
    { input: 'she', output: 'しぇ' },
    { input: 'sho', output: 'しょ' },

    { input: 'ssha', output: 'っしゃ' },
    { input: 'sshi', output: 'っし' },
    { input: 'sshu', output: 'っしゅ' },
    { input: 'sshe', output: 'っしぇ' },
    { input: 'ssho', output: 'っしょ' },

    { input: 'swa', output: 'すぁ' },
    { input: 'swi', output: 'すぃ' },
    { input: 'swu', output: 'すぅ' },
    { input: 'swe', output: 'すぇ' },
    { input: 'swo', output: 'すぉ' },

    { input: 'sswa', output: 'っすぁ' },
    { input: 'sswi', output: 'っすぃ' },
    { input: 'sswu', output: 'っすぅ' },
    { input: 'sswe', output: 'っすぇ' },
    { input: 'sswo', output: 'っすぉ' },

    { input: 'zya', output: 'じゃ' },
    { input: 'zyi', output: 'じぃ' },
    { input: 'zyu', output: 'じゅ' },
    { input: 'zye', output: 'じぇ' },
    { input: 'zyo', output: 'じょ' },

    { input: 'zzya', output: 'っじゃ' },
    { input: 'zzyi', output: 'っじぃ' },
    { input: 'zzyu', output: 'っじゅ' },
    { input: 'zzye', output: 'っじぇ' },
    { input: 'zzyo', output: 'っじょ' },

    { input: 'ja', output: 'じゃ' },
    { input: 'ji', output: 'じ' },
    { input: 'ju', output: 'じゅ' },
    { input: 'je', output: 'じぇ' },
    { input: 'jo', output: 'じょ' },

    { input: 'jja', output: 'っじゃ' },
    { input: 'jji', output: 'っじ' },
    { input: 'jju', output: 'っじゅ' },
    { input: 'jje', output: 'っじぇ' },
    { input: 'jjo', output: 'っじょ' },

    { input: 'jya', output: 'じゃ' },
    { input: 'jyya', output: 'っじゃ' },

    { input: 'tya', output: 'ちゃ' },
    { input: 'tyi', output: 'ちぃ' },
    { input: 'tyu', output: 'ちゅ' },
    { input: 'tye', output: 'ちぇ' },
    { input: 'tyo', output: 'ちょ' },

    { input: 'ttya', output: 'っちゃ' },
    { input: 'ttyi', output: 'っちぃ' },
    { input: 'ttyu', output: 'っちゅ' },
    { input: 'ttye', output: 'っちぇ' },
    { input: 'ttyo', output: 'っちょ' },

    { input: 'cha', output: 'ちゃ' },
    { input: 'chi', output: 'ち' },
    { input: 'chu', output: 'ちゅ' },
    { input: 'che', output: 'ちぇ' },
    { input: 'cho', output: 'ちょ' },

    { input: 'ccha', output: 'っちゃ' },
    { input: 'cchi', output: 'っち' },
    { input: 'cchu', output: 'っちゅ' },
    { input: 'cche', output: 'っちぇ' },
    { input: 'ccho', output: 'っちょ' },

    { input: 'tha', output: 'てゃ' },
    { input: 'thi', output: 'てぃ' },
    { input: 'thu', output: 'てゅ' },
    { input: 'the', output: 'てぇ' },
    { input: 'tho', output: 'てょ' },

    { input: 'ttha', output: 'ってゃ' },
    { input: 'tthi', output: 'ってぃ' },
    { input: 'tthu', output: 'ってゅ' },
    { input: 'tthe', output: 'ってぇ' },
    { input: 'ttho', output: 'ってょ' },

    { input: 'twa', output: 'とぁ' },
    { input: 'twi', output: 'とぃ' },
    { input: 'twu', output: 'とぅ' },
    { input: 'twe', output: 'とぇ' },
    { input: 'two', output: 'とぉ' },

    { input: 'ttwa', output: 'っとぁ' },
    { input: 'ttwi', output: 'っとぃ' },
    { input: 'ttwu', output: 'っとぅ' },
    { input: 'ttwe', output: 'っとぇ' },
    { input: 'ttwo', output: 'っとぉ' },

    { input: 'dya', output: 'ぢゃ' },
    { input: 'dyi', output: 'ぢぃ' },
    { input: 'dyu', output: 'ぢゅ' },
    { input: 'dye', output: 'ぢぇ' },
    { input: 'dyo', output: 'ぢょ' },

    { input: 'ddya', output: 'っぢゃ' },
    { input: 'ddyi', output: 'っぢぃ' },
    { input: 'ddyu', output: 'っぢゅ' },
    { input: 'ddye', output: 'っぢぇ' },
    { input: 'ddyo', output: 'っぢょ' },

    { input: 'dha', output: 'でゃ' },
    { input: 'dhi', output: 'でぃ' },
    { input: 'dhu', output: 'でゅ' },
    { input: 'dhe', output: 'でぇ' },
    { input: 'dho', output: 'でょ' },

    { input: 'ddha', output: 'っでゃ' },
    { input: 'ddhi', output: 'っでぃ' },
    { input: 'ddhu', output: 'っでゅ' },
    { input: 'ddhe', output: 'っでぇ' },
    { input: 'ddho', output: 'っでょ' },

    { input: 'dwa', output: 'どぁ' },
    { input: 'dwi', output: 'どぃ' },
    { input: 'dwu', output: 'どぅ' },
    { input: 'dwe', output: 'どぇ' },
    { input: 'dwo', output: 'どぉ' },

    { input: 'ddwa', output: 'っどぁ' },
    { input: 'ddwi', output: 'っどぃ' },
    { input: 'ddwu', output: 'っどぅ' },
    { input: 'ddwe', output: 'っどぇ' },
    { input: 'ddwo', output: 'っどぉ' },

    { input: 'nya', output: 'にゃ' },
    { input: 'nyi', output: 'にぃ' },
    { input: 'nyu', output: 'にゅ' },
    { input: 'nye', output: 'にぇ' },
    { input: 'nyo', output: 'にょ' },

    { input: 'hya', output: 'ひゃ' },
    { input: 'hyi', output: 'ひぃ' },
    { input: 'hyu', output: 'ひゅ' },
    { input: 'hye', output: 'ひぇ' },
    { input: 'hyo', output: 'ひょ' },

    { input: 'hhya', output: 'っひゃ' },
    { input: 'hhyi', output: 'っひぃ' },
    { input: 'hhyu', output: 'っひゅ' },
    { input: 'hhye', output: 'っひぇ' },
    { input: 'hhyo', output: 'っひょ' },

    { input: 'fa', output: 'ふぁ' },
    { input: 'fi', output: 'ふぃ' },
    { input: 'fu', output: 'ふ' },
    { input: 'fe', output: 'ふぇ' },
    { input: 'fo', output: 'ふぉ' },

    { input: 'ffa', output: 'っふぁ' },
    { input: 'ffi', output: 'っふぃ' },
    { input: 'ffu', output: 'っふ' },
    { input: 'ffe', output: 'っふぇ' },
    { input: 'ffo', output: 'っふぉ' },

    { input: 'fwa', output: 'ふぁ' },
    { input: 'fwi', output: 'ふぃ' },
    { input: 'fwu', output: 'ふぅ' },
    { input: 'fwe', output: 'ふぇ' },
    { input: 'fwo', output: 'ふぉ' },

    { input: 'ffwa', output: 'っふぁ' },
    { input: 'ffwi', output: 'っふぃ' },
    { input: 'ffwu', output: 'っふぅ' },
    { input: 'ffwe', output: 'っふぇ' },
    { input: 'ffwo', output: 'っふぉ' },

    { input: 'fya', output: 'ふゃ' },
    { input: 'fyi', output: 'ふぃ' },
    { input: 'fyu', output: 'ふゅ' },
    { input: 'fye', output: 'ふぇ' },
    { input: 'fyo', output: 'ふょ' },

    { input: 'ffya', output: 'っふゃ' },
    { input: 'ffyi', output: 'っふぃ' },
    { input: 'ffyu', output: 'っふゅ' },
    { input: 'ffye', output: 'っふぇ' },
    { input: 'ffyo', output: 'っふょ' },

    { input: 'bya', output: 'びゃ' },
    { input: 'byi', output: 'びぃ' },
    { input: 'byu', output: 'びゅ' },
    { input: 'bye', output: 'びぇ' },
    { input: 'byo', output: 'びょ' },

    { input: 'bbya', output: 'っびゃ' },
    { input: 'bbyi', output: 'っびぃ' },
    { input: 'bbyu', output: 'っびゅ' },
    { input: 'bbye', output: 'っびぇ' },
    { input: 'bbyo', output: 'っびょ' },

    { input: 'pya', output: 'ぴゃ' },
    { input: 'pyi', output: 'ぴぃ' },
    { input: 'pyu', output: 'ぴゅ' },
    { input: 'pye', output: 'ぴぇ' },
    { input: 'pyo', output: 'ぴょ' },

    { input: 'ppya', output: 'っぴゃ' },
    { input: 'ppyi', output: 'っぴぃ' },
    { input: 'ppyu', output: 'っぴゅ' },
    { input: 'ppye', output: 'っぴぇ' },
    { input: 'ppyo', output: 'っぴょ' },

    { input: 'mya', output: 'みゃ' },
    { input: 'myi', output: 'みぃ' },
    { input: 'myu', output: 'みゅ' },
    { input: 'mye', output: 'みぇ' },
    { input: 'myo', output: 'みょ' },

    { input: 'mmya', output: 'っみゃ' },
    { input: 'mmyi', output: 'っみぃ' },
    { input: 'mmyu', output: 'っみゅ' },
    { input: 'mmye', output: 'っみぇ' },
    { input: 'mmyo', output: 'っみょ' },

    { input: 'rya', output: 'りゃ' },
    { input: 'ryi', output: 'りぃ' },
    { input: 'ryu', output: 'りゅ' },
    { input: 'rye', output: 'りぇ' },
    { input: 'ryo', output: 'りょ' },

    { input: 'rrya', output: 'っりゃ' },
    { input: 'rryi', output: 'っりぃ' },
    { input: 'rryu', output: 'っりゅ' },
    { input: 'rrye', output: 'っりぇ' },
    { input: 'rryo', output: 'っりょ' },

    { input: 'wha', output: 'うぁ' },
    { input: 'whi', output: 'うぃ' },
    { input: 'whe', output: 'うぇ' },
    { input: 'who', output: 'うぉ' },

    { input: 'wwha', output: 'っうぁ' },
    { input: 'wwhi', output: 'っうぃ' },
    { input: 'wwhe', output: 'っうぇ' },
    { input: 'wwho', output: 'っうぉ' },

    { input: 'xtu', output: 'っ' },
    { input: 'xya', output: 'ゃ' },
    { input: 'xyu', output: 'ゅ' },
    { input: 'xyo', output: 'ょ' },

    { input: 'ltu', output: 'っ' },
    { input: 'lya', output: 'ゃ' },
    { input: 'lyu', output: 'ゅ' },
    { input: 'lyo', output: 'ょ' },

    { input: 'xwa', output: 'ゎ' },
    { input: 'xke', output: 'ヶ' },
    { input: 'xka', output: 'ヵ' },

    { input: 'lwa', output: 'ゎ' },
    { input: 'lke', output: 'ヶ' },
    { input: 'lka', output: 'ヵ' },

    { input: 'va', output: 'ゔぁ' },
    { input: 'vi', output: 'ゔぃ' },
    { input: 'vu', output: 'ゔ' },
    { input: 've', output: 'ゔぇ' },
    { input: 'vo', output: 'ゔぉ' },

    // { input: 'nkyo', output: 'んきょ' },
    // { input: 'nka', output: 'んか' },
    // { input: 'nko', output: 'んこ' },
    // { input: 'nno', output: 'んの' },
    // { input: 'nto', output: 'んと' },
    // { input: 'ndo', output: 'んど' },

    { input: ',', output: '、' },
    { input: '.', output: '。' },
    { input: '/', output: '・' },
    { input: ';', output: '；' },
    { input: '-', output: 'ー' }
  ]

  isVowel(keyCode) {
    return _.includes(['KeyA', 'KeyI', 'KeyU', 'KeyE', 'KeyO'], keyCode)
  }

  isConvertable(preText) {
    const matchedPattern = this.getPatternByRomaji(preText)
    return !_.isEmpty(matchedPattern)
  }

  isVaild(preText) {
    return _.findIndex(this.CONVERSION_PATTERNS, (o) => {
      return o.input.startsWith(preText)
    }) !== -1
  }

  getPatternByRomaji(romaji) {
    const pattern = _.find(this.CONVERSION_PATTERNS, { input: romaji })
    return pattern
  }

  getRomajiByHiragana(hiragana) {
    const pattern = _.find(this.CONVERSION_PATTERNS, { output: hiragana })
    return pattern ? pattern.input : '' // ' '
  }

  getRomajiByHiraganaText(text) {
    const characters = text.split('')
    let isSkipNext = false
    return characters
      .map((hiragana, i) => {
        if (isSkipNext) {
          isSkipNext = false
          return ''
        }
        const oneCharacterRomaji = this.getRomajiByHiragana(hiragana)
        const twoCharacterRomaji = this.getRomajiByHiragana(
          `${hiragana}${characters[i + 1]}`
        )
        if (twoCharacterRomaji) {
          isSkipNext = true
          return twoCharacterRomaji
        } else {
          return oneCharacterRomaji
        }
      })
      .join('')
  }

  getKeyDetail(keycode) {
    return _.find(this.ACCEPTED_KEYS, { code: keycode })
  }
}

export default new InputService()
